module.exports = __webpack_public_path__ + "img/37929c0.jpg";